'use client'

import { HomeContainer } from '@/components/common'
import { useIsMobileClient } from '@/hooks/common/use-device-type'
import { useMemberActivitiesQuery } from '@/hooks/react-query/club/use-member-activities'
import { __cRedisService } from '@/services/client/__c.redis.service'
import { useEffect, useState } from 'react'
import { CoolClubAwarenessContent } from './content'
import { cn } from '@/lib/utils'
import { CoolClubAwarenessContentDesktop } from './content-desktop'

export const CoolClubAwareness = ({ className }: { className?: string }) => {
  const isMobile = useIsMobileClient()
  const { data: activities, isLoading: isLoadingActivities } =
    useMemberActivitiesQuery()
  const [total, setTotal] = useState(365439)

  useEffect(() => {
    __cRedisService.getByApi<number>('coolclub_total').then((result) => {
      if (result) setTotal(result)
    })
  }, [])

  if (isLoadingActivities) return <CoolClubAwarenessSkeleton />
  if (!activities) return null

  if (isMobile) {
    return (
      <CoolClubAwarenessContent
        data={activities}
        total={total}
        className={className}
      />
    )
  }

  return (
    <CoolClubAwarenessContentDesktop
      data={activities}
      total={total ?? 365439}
      className={className}
    />
  )
}

export const CoolClubAwarenessSkeleton = () => {

  return (
    <div className='animate-pulse'>
      <HomeContainer>
        <div
          className={cn(
            'mb-10 rounded-2xl py-5 lg:mb-15 lg:flex lg:pt-11',
            'bg-neutral-100'
          )}
        >
          {/* Left Column */}
          <div className='border-b border-b-neutral-300 px-8 pb-11 lg:flex-1 lg:border-0 lg:px-12'>
            <div className='mb-4 h-8 w-3/4 rounded-md bg-neutral-200 lg:h-8 lg:w-2/3' />

            <div className='space-y-4 lg:flex lg:items-stretch lg:space-x-4 lg:space-y-0'>
              {[...Array(3)].map((_, i) => (
                <div
                  key={i}
                  className='h-24 w-full rounded-lg bg-neutral-200 lg:h-32 lg:flex-1'
                />
              ))}
            </div>
          </div>

          {/* Right Column */}
          <div className='mt-4 px-8 lg:mt-0 lg:basis-5/12 lg:border-l lg:border-neutral-200 lg:px-12'>
            <div className='mx-auto mb-6 h-6 w-1/2 rounded-md bg-neutral-200' />

            <div className='space-y-3'>
               <div className='flex gap-3'>
                  <div className='h-6 w-1/3 rounded bg-neutral-200'/>
                  <div className='h-6 w-1/3 rounded bg-neutral-200'/>
                  <div className='h-6 w-1/3 rounded bg-neutral-200'/>
               </div>
               <div className='flex gap-3'>
                  <div className='h-6 w-1/3 rounded bg-neutral-200'/>
                  <div className='h-6 w-1/3 rounded bg-neutral-200'/>
                  <div className='h-6 w-1/3 rounded bg-neutral-200'/>
               </div>
            </div>

            <div className='mt-6 h-10 w-full rounded-full bg-neutral-200 lg:mt-8' />
          </div>
        </div>
      </HomeContainer>
    </div>
  )
}
